import React, { useEffect, useMemo, useState } from 'react'
import MasterService from '../../services/master/MasterService'
import { Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import { FaDownload } from 'react-icons/fa'
import DataTable from 'react-data-table-component'

const MasterIkanHsModal = ({showHsModal, handleCloseHsModal}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const columns = [
        {
            name: 'HS Code',
            cell: row => row['kodeHs'],
            grow: 0.1
        },
        {
            name: 'Uraian Indonesia',
            cell: row => row['uraianId']
        },
        {
            name: 'Uraian',
            cell: row => row['uraianEn']
        },
        {
            name: 'Tahun',
            cell: row => row['tahun'],
            grow: 0
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    <div className="col-12 mb-1">
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip >Pilih</Tooltip>}>

                            <Button size="sm" variant="primary" onClick={() => pilihDataHs(row)}>
                                <FaDownload /> Pilih
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            ),
            grow: 0.25
        }
    ]

    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const pilihDataHs = (row) => {
        handleCloseHsModal(row)
    }

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true)
                const resHs = await masterService.listHs(null, null, 0, 10)
                setListData(resHs.data.data)
                setTotalData(resHs.data.totalData)
                setLoading(false)
            } catch (error) {
                setLoading(false)
                setListData([])
            }
        }
        fetchAllData()
    }, [masterService])

    const handleChangePage = async (page) => {
        setLoading(true)
        const resHs = await masterService.listHs(null, null, page, 10)
        setListData(resHs.data.data)
        setTotalData(resHs.data.totalData)
        setLoading(false)
    }

    const handlePerRowsChange = async (size, page) => {
        setLoading(true)
        const _res = await masterService.listHs(null, null, page - 1, 10)
        setListData(_res.data.data)
        setSize(size)
        setLoading(false)
    }

    const onChangeSearchHs = async (e) => {
        setLoading(true)
        const _res = await masterService.listHs(e.target.value, e.target.value, 0, 10)
        setListData(_res.data.data)
        setSize(size)
        setLoading(false)
    }


    return (
        <>
            <Modal 
                show={showHsModal}
                onHide={handleCloseHsModal}
                backdrop='static'
                keyboard={false}
                size='xl'
                centered
            >
                <Modal.Header>
                    <h6>Pilih HS</h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-6">
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Cari</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="HS Code / Uraian" className="form-control-sm" onChange={(e) => onChangeSearchHs(e)} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="table-responsive border-bottom my-3">
                        {loading && <Spinner />}
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columns}
                            data={listData}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={totalData}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            persistTableHead={true}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default MasterIkanHsModal